import { keymap } from "prosemirror-keymap";
import {
    autoJoin,
    chainCommands,
    deleteSelection,
    joinBackward,
    selectNodeBackward,
    joinTextblockForward,
    joinForward,
    selectNodeForward,
} from "prosemirror-commands";
import {
    indent,
    joinTopLevelWithPreviousListItem,
    liftListItemIfAtStart,
    unindent,
} from "@/wc/text-editor/lib/core/commands.js";

import { Schema } from "prosemirror-model";
import { Plugin } from "prosemirror-state";

const backspace = (schema: Schema) =>
    autoJoin(
        chainCommands(
            deleteSelection,
            liftListItemIfAtStart(schema.nodes.list_item),
            joinTopLevelWithPreviousListItem,
            // joinTextblockBackward,
            joinBackward,
            selectNodeBackward
        ),
        ["ordered_list", "unordered_list"]
    );

const del = chainCommands(
    deleteSelection,
    joinTextblockForward,
    joinForward,
    selectNodeForward
);

export const defaultKeymaps = (schema: Schema): Plugin =>
    keymap({
        "Tab": indent(schema),
        "Shift-Tab": unindent(schema),
        "Backspace": backspace(schema),
        "Delete": del,
    });
